export const commApi = {
  CHECK_PREVIOUS_REGISTRATION: '/api/common/send-email-otp',
  CREATE_PREVIOUS_REGISTRATION: '/api/auth/previous-registration',
  MATCH_OTP: '/api/common/match-email-otp',
};
